import React from 'react';
import { Global } from '@emotion/core';
import global from '../../styles/global';

import LayoutHeader from './LayoutHeader';
import Footer from '../Footer';
import NewFooter from '../Homepage/Footer';
import '../../styles/blog/app.scss';
import BlueFooter from '../Homepage/BlueFooter';
import OldBlueFooter from '../Homepage/OldBlueFooter';
import { useIntl } from 'react-intl';
import { OpenSansParagraph } from '../common/typography';

export interface LayoutProps {
  hideLanguageSwap?: boolean;
  isNewLayout?: boolean;
  isDarkHeader?: boolean;
  noHeader?: boolean;
  noFooter?: boolean;
  simpleHeader?: boolean;
  simpleFooter?: boolean;
  hideCallToAction?: boolean;
  footerType?: 'prescription' | 'heartburn';
  prescriptionLink?: string;
  footerData?: {
    'de': {
      title: string;
      text: string;
      buttonText: string;
      buttonUrl: string;
      buttonType: '' | 'typeform' | 'link';
    },
    'en': {
      title: string;
      text: string;
      buttonText: string;
      buttonUrl: string;
      buttonType: '' | 'typeform' | 'link';
    }
  };
}

type Props = LayoutProps;

const Layout: React.FC<Props> = ({
  children,
  hideLanguageSwap = false,
  isNewLayout = false,
  isDarkHeader = false,
  noHeader = false,
  noFooter = false,
  simpleHeader = false,
  simpleFooter = false,
  hideCallToAction = false,
  footerType = 'prescription',
  footerData = {
    'de': {
      title: '',
      text: '',
      buttonText: '',
      buttonUrl: '',
      buttonType: '',
    },
    'en': {
      title: '',
      text: '',
      buttonText: '',
      buttonUrl: '',
      buttonType: '',
    }
  },
  prescriptionLink,
}) => {
  const intl = useIntl();

  const renderFooter = () => {
    if (isNewLayout) {
      return <NewFooter simpleFooter={simpleFooter} />;
    }

    if (footerType === 'prescription') {
      return <BlueFooter type="prescription" />;
    }

    if (footerType === 'heartburn') {
      return <OldBlueFooter type="heartburn" footerData={footerData} />;
    }

    return <Footer />;
  };

  return (
    <>
      <Global styles={global} />

      {noHeader ? (
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#235544',
            padding: 10,
          }}
        >
          <OpenSansParagraph
            css={{
              color: '#fff',
              fontSize: 14,
              paddingLeft: '1rem',
              paddingRight: '1rem',
              opacity: 1,
            }}
          >
            {' '}
            {intl.formatMessage({
              id: 'nav.header.header.announcement',
              defaultMessage:
                'Zum ersten Quartal 2025 übernimmt Bayer die HiDoc Technologies GmbH, das Unternehmen hinter Cara Care für Reizdarm',
            })}{' '}
            <a
              target="_blank"
              rel="noreferrer noopener"
              css={{
                textDecoration: 'underline',
                color: '#fff',
              }}
              href={intl.formatMessage({
                id: 'nav.header.header.announcement.link.url',
                defaultMessage:
                  'https://www.bayer.com/media/erste-diga-von-bayer-cara-care-fuer-reizdarm/',
              })}
            >
              {intl.formatMessage({
                id: 'nav.header.header.announcement.link',
                defaultMessage: 'Click here to learn more.',
              })}
            </a>
          </OpenSansParagraph>
        </div>
      ) : (
        <LayoutHeader
          {...{
            isNewLayout,
            hideLanguageSwap,
            isDarkHeader,
            hideCallToAction,
            prescriptionLink,
            simpleHeader,
          }}
        />
      )}
      <main
        css={{
          flex: '1 0 auto',
          margin: '10px 0',
          transition: 'margin-top 0.5s',
          marginTop: 'calc(10rem + 30px)',
          '@media (max-width: 768px)': {
            marginTop:
              intl.locale === 'de'
                ? 'calc(13rem + 60px)'
                : 'calc(10rem + 60px)',
          },
        }}
      >
        {children}
      </main>
      {noFooter ? null : renderFooter()}
    </>
  );
};

export default Layout;
